import Vue from 'vue'
import VueRouter from 'vue-router'

import { getToken } from '@/utils/auth'

import BottomMenu from '@/components/BottomMenu'
import BottomMenuAuth from '@/components/BottomMenuAuth'

import Register from '@/views/Register'
import Login from '@/views/Login'
import HowTo from '@/views/HowTo'
import Contact from '@/views/Contact'
import Page404 from '@/views/Page404'
import Terminated from '@/views/Terminated'

import UserHome from '@/views/user/Home'
import UserProfile from '@/views/user/Profile'
import UserBonus from '@/views/user/Bonus'
import UserStatement from '@/views/user/Statement'
import UserSpin from '@/views/user/Spin'
import UserRanking from '@/views/user/Ranking'

import apiLookup from '@/api/lookup'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'NotUser',
    component: BottomMenu,
    redirect: '/user',
    children: [
      {
        path: 'login',
        name: 'Login',
        component: Login,
        props: { page: 'login' }
      },
      {
        path: 'register',
        name: 'Register',
        component: Register,
        props: { page: 'register' }
      },
      {
        path: 'howto',
        name: 'HowTo',
        component: HowTo,
        props: { page: 'howto' }
      },
      {
        path: 'contact',
        name: 'Contact',
        component: Contact,
        props: { page: 'contact', hasTop: false }
      }
    ]
  },
  {
    path: '/user',
    name: 'User',
    component: BottomMenuAuth,
    redirect: '/user/home',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'home',
        name: 'UserHome',
        component: UserHome,
        props: { page: 'home' }
      },
      {
        path: 'profile',
        name: 'UserProfile',
        component: UserProfile,
        props: { page: 'profile' }
      },
      {
        path: 'bonus',
        name: 'UserBonus',
        component: UserBonus,
        props: { page: 'bonus' }
      },
      {
        path: 'statement',
        name: 'UserStatement',
        component: UserStatement,
        props: { page: 'statement' }
      },
      {
        path: 'contact',
        name: 'UserContact',
        component: Contact,
        props: { page: 'contact', hasTop: true }
      },
      {
        path: 'spin',
        name: 'UserSpin',
        component: UserSpin,
        props: { page: 'spin' }
      },
      {
        path: 'ranking',
        name: 'UserRanking',
        component: UserRanking,
        props: { page: 'ranking' }
      }
    ]
  },
  {
    path: '/terminated',
    name: 'Terminated',
    component: Terminated // 404
  },
  {
    path: '*',
    name: 'Page404',
    component: Page404 // 404
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (window.location.pathname === '/login') {
    document.body.className = 'terminated'

    const data = await apiLookup.lookupActive()
    if (data.terminated === 'gone') {
      next({ path: '/terminated' })
    } else {
      document.body.className = ''
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (getToken() == null) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
